var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIconWeek(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 207,
    width: 20,
    height: 21
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-19 -207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04167 5.41667C6.39583 5.41667 6.66667 5.14583 6.66667 4.79167L6.66667 3.54167C6.66667 3.1875 6.39583 2.91667 6.04167 2.91667 5.6875 2.91667 5.41667 3.1875 5.41667 3.54167L5.41667 4.79167C5.41667 5.14583 5.6875 5.41667 6.04167 5.41667Z",
    fill: "#7030A0",
    transform: "matrix(1 0 0 1.05 19 207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 14.1667 7.5 14.1667 7.5 15.8333 4.16667 15.8333 4.16667 14.1667ZM4.16667 11.6667 7.5 11.6667 7.5 13.3333 4.16667 13.3333 4.16667 11.6667ZM4.16667 9.16667 7.5 9.16667 7.5 10.8333 4.16667 10.8333 4.16667 9.16667ZM11.6667 9.16667 11.6667 10.8333 8.33333 10.8333 8.33333 9.16667 11.6667 9.16667ZM15.8333 9.16667 15.8333 10.8333 12.5 10.8333 12.5 9.16667 15.8333 9.16667ZM15.8333 13.3333 12.5 13.3333 12.5 11.6667 15.8333 11.6667 15.8333 13.3333ZM15.8333 15.8333 12.5 15.8333 12.5 14.1667 15.8333 14.1667 15.8333 15.8333ZM8.33333 13.3333 8.33333 11.6667 11.6667 11.6667 11.6667 13.3333 8.33333 13.3333ZM8.33333 15.8333 8.33333 14.1667 11.6667 14.1667 11.6667 15.8333 8.33333 15.8333ZM2.91667 17.0833 17.0833 17.0833 17.0833 7.91667 2.91667 7.91667 2.91667 17.0833Z",
    fill: "#7030A0",
    transform: "matrix(1 0 0 1.05 19 207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9583 5.41667C14.3125 5.41667 14.5833 5.14583 14.5833 4.79167L14.5833 3.54167C14.5833 3.1875 14.3125 2.91667 13.9583 2.91667 13.6042 2.91667 13.3333 3.1875 13.3333 3.54167L13.3333 4.79167C13.3333 5.14583 13.6042 5.41667 13.9583 5.41667Z",
    fill: "#7030A0",
    transform: "matrix(1 0 0 1.05 19 207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 4.16667 15.4167 4.79167C15.4167 5.60417 14.7708 6.25 13.9583 6.25 13.1458 6.25 12.5 5.60417 12.5 4.79167L12.5 4.16667 7.5 4.16667 7.5 4.79167C7.5 5.60417 6.85417 6.25 6.04167 6.25 5.22917 6.25 4.58333 5.60417 4.58333 4.79167L4.58333 4.16667 2.91667 4.16667 2.91667 7.08333 17.0833 7.08333 17.0833 4.16667 15.4167 4.16667Z",
    fill: "#7030A0",
    transform: "matrix(1 0 0 1.05 19 207)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconWeek);
export default __webpack_public_path__ + "static/media/nav-icon-week.2318e323d92f409e7731f0ef3e9a2710.svg";
export { ForwardRef as ReactComponent };